export class TaskTypeDynamicFieldApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFields({ companyId }) {
    return this.#http.get(`/api/companies/${companyId}/taskTypes/dynamicFields`);
  }
}
